(function(){
  'use strict';

  function initHero(root){
    if(!root || root.dataset.ready==='1') return;
    root.dataset.ready='1';

    var track=root.querySelector('[data-arshe-hero-track]');
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-arshe-hero-slide]'));
    var dots=root.querySelector('[data-arshe-hero-dots]');
    var prev=root.querySelector('[data-arshe-hero-prev]');
    var next=root.querySelector('[data-arshe-hero-next]');
    if(!track || !slides.length) return;

    var index=0;
    var timer=null;
    var restartTimer=null;
    var pointerId=null;
    var startX=0;
    var currentX=0;
    var dragging=false;
    var moved=false;
    var suppressClick=false;

    function prefersReducedMotion(){
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function render(animate){
      track.style.transition = animate === false || prefersReducedMotion()
        ? 'none'
        : '';
      track.style.transform='translate3d(' + (-index * 100) + '%,0,0)';

      slides.forEach(function(slide,i){
        slide.setAttribute('aria-hidden',i===index?'false':'true');
      });

      if(dots){
        Array.prototype.forEach.call(dots.children,function(dot,i){
          dot.classList.toggle('is-active',i===index);
          dot.setAttribute('aria-current',i===index?'true':'false');
        });
      }
    }

    function go(n,animate){
      index=(n+slides.length)%slides.length;
      render(animate);
    }

    function stop(){
      if(timer){window.clearInterval(timer);timer=null;}
      if(restartTimer){window.clearTimeout(restartTimer);restartTimer=null;}
    }

    function start(){
      stop();
      if(prefersReducedMotion() || slides.length<2) return;
      var interval=window.matchMedia('(max-width: 749px)').matches?5000:5500;
      timer=window.setInterval(function(){go(index+1,true);},interval);
    }

    function scheduleRestart(){
      if(restartTimer) window.clearTimeout(restartTimer);
      restartTimer=window.setTimeout(start,9000);
    }

    if(dots){
      slides.forEach(function(_,i){
        var button=document.createElement('button');
        button.type='button';
        button.setAttribute('aria-label','Go to slide '+(i+1));
        button.addEventListener('click',function(){
          stop();
          go(i,true);
          scheduleRestart();
        });
        dots.appendChild(button);
      });
    }

    if(prev) prev.addEventListener('click',function(){
      stop(); go(index-1,true); scheduleRestart();
    });

    if(next) next.addEventListener('click',function(){
      stop(); go(index+1,true); scheduleRestart();
    });

    root.addEventListener('pointerdown',function(e){
      if(e.pointerType==='mouse' && e.button!==0) return;
      if(e.target.closest('button')) return;
      pointerId=e.pointerId;
      startX=e.clientX;
      currentX=e.clientX;
      dragging=true;
      moved=false;
      suppressClick=false;
      track.classList.add('is-dragging');
      if(root.setPointerCapture) root.setPointerCapture(pointerId);
      stop();
    });

    root.addEventListener('pointermove',function(e){
      if(!dragging || e.pointerId!==pointerId) return;
      currentX=e.clientX;
      var dx=currentX-startX;
      if(Math.abs(dx)>8) moved=true;
      if(!moved) return;
      e.preventDefault();
      var width=root.getBoundingClientRect().width || 1;
      var percent=(dx/width)*100;
      track.style.transform='translate3d(' + (-index*100+percent) + '%,0,0)';
    },{passive:false});

    function finishPointer(e){
      if(!dragging || (e && e.pointerId!==pointerId)) return;
      var dx=currentX-startX;
      dragging=false;
      track.classList.remove('is-dragging');
      if(root.releasePointerCapture && pointerId!==null){
        try{root.releasePointerCapture(pointerId);}catch(err){}
      }
      pointerId=null;

      if(Math.abs(dx)>45){
        suppressClick=true;
        go(index+(dx<0?1:-1),true);
      }else{
        render(true);
      }
      if(Math.abs(dx)>8) scheduleRestart(); else start();
      if(suppressClick){
        window.setTimeout(function(){suppressClick=false;},350);
      }
    }

    root.addEventListener('pointerup',finishPointer);
    root.addEventListener('pointercancel',finishPointer);
    root.addEventListener('click',function(e){
      if(suppressClick){
        e.preventDefault();
        e.stopPropagation();
        suppressClick=false;
      }
    },true);

    root.addEventListener('mouseenter',function(){
      if(!dragging) stop();
    });
    root.addEventListener('mouseleave',function(){
      if(!dragging) start();
    });

    document.addEventListener('visibilitychange',function(){
      if(document.hidden) stop(); else start();
    });

    render(false);
    start();
  }

  function bindScentTriggers(){
    document.addEventListener('click',function(e){
      var trigger=e.target.closest('[data-arshe-home-scent-trigger]');
      if(!trigger)return;
      var fab=document.querySelector('[data-arshe-scent-finder] [data-sf-open]');
      if(fab){e.preventDefault();fab.click();}
    });
  }

  function init(){
    document.querySelectorAll('[data-arshe-home-hero]').forEach(initHero);
    bindScentTriggers();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
